module.exports = __webpack_public_path__ + "img/acc7.cbbc3c36.png";